import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const TILE = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

const numberedPin = (n, color) =>
  L.divIcon({
    className: "cph-mini-pin",
    html: `<div style="
      background:${color};width:22px;height:22px;border-radius:50%;
      border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,0.35);
      display:flex;align-items:center;justify-content:center;
      color:#fff;font-family:'Plus Jakarta Sans',sans-serif;font-weight:800;font-size:12px;line-height:1;">${n}</div>`,
    iconSize: [22, 22],
    iconAnchor: [11, 11],
  });

function Frame({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length > 1) {
      map.fitBounds(L.latLngBounds(points), { padding: [26, 26], maxZoom: 15 });
    } else if (points.length === 1) {
      map.setView(points[0], 14);
    }
  }, []);
  return null;
}

// A small, non-interactive preview of one day's stops, plotted in order.
// festive (Nov/Dec trips): pins alternate red/green, route line runs pine green.
// heightClass: "h-36" inside day cards, taller when used as a page route map.
export const DayMiniMap = ({ items, color = "#DF3226", festive = false, heightClass = "h-36" }) => {
  const points = (items || []).filter((s) => Array.isArray(s.coords)).map((s) => s.coords);
  if (!points.length) return null;
  const pinColor = (i) => (festive ? (i % 2 ? "#0E5C3A" : "#DF3226") : color);
  const lineColor = festive ? "#0E5C3A" : color;

  return (
    <div
      data-testid="day-mini-map"
      className={`rounded-xl overflow-hidden border border-zinc-200 ${heightClass} mb-4 pointer-events-none select-none`}
    >
      <MapContainer
        center={points[0]}
        zoom={13}
        style={{ height: "100%", width: "100%" }}
        dragging={false}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        touchZoom={false}
        boxZoom={false}
        keyboard={false}
        zoomControl={false}
        attributionControl={false}
      >
        <TileLayer url={TILE} maxZoom={19} className="cph-map-tiles" />
        <Frame points={points} />
        {points.length > 1 && (
          <Polyline positions={points} pathOptions={{ color: lineColor, weight: 3, opacity: 0.7, dashArray: "1 8", lineCap: "round" }} />
        )}
        {points.map((p, i) => (
          <Marker key={i} position={p} icon={numberedPin(i + 1, pinColor(i))} interactive={false} />
        ))}
      </MapContainer>
    </div>
  );
};
